<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: "App",
  data: () => ({}),
};
</script>

<style lang="scss">
@import url('https://fonts.googleapis.com/css2?family=Sarabun:wght@300;400;500&family=Roboto:wght@300;400;500&display=swap');

$text: #345;
$subtext: #737e8a;
$border: #efefef;

.v-application {
  font-family: Roboto, Sarabun, sans-serif !important;
  font-weight: 400;
  line-height: 1.5;
  font-size: 0.875rem;
  color: $text !important;
  background: #f5f5f5 !important;
}

h1,
h2,
h3 {
  font-weight: 400;
}
h1 {
  font-size: 2rem;
}
h2 {
  font-size: 1.25rem;
}
h3 {
  font-size: 1rem;
}
.subtitle {
  color: $subtext;
  font-size: 0.875rem;
  opacity: 0.75;
}
p {
  margin-bottom: 0 !important;
}

i {
  font-size: 1rem !important;
}

.summary {
  border-bottom: 1px solid $border;
}

.v-toolbar__content {
  flex-wrap: wrap !important;
  height: auto !important;
}

header {
  height: auto !important;
}

.fullwidth {
  width: 100%;
}
</style>
